import { Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { HttpService } from 'src/app/http.service';
import { TableComponent } from '../table/table.component';

@Component({
  selector: 'app-topup-withdraw',
  templateUrl: './topup-withdraw.component.html',
  styleUrls: ['./topup-withdraw.component.scss']
})
export class TopupWithdrawComponent {

  public data: any = {};
  public company_uuid;
  public setting : any = {};
  @ViewChild('f') f : NgForm
  @ViewChild("table", { static: false }) tb: TableComponent;

  constructor(private http: HttpService,  private cdr: ChangeDetectorRef) {
    this.company_uuid = this.http.getStaticSelectedCompany();

    this.setting = 
      { post: {url: '/admin/player/get', data: this.data},
        disabled_pagenat: false,
        fields: [
          {label: 'No', type: 'index'}, 
          {label: 'Code', type: 'string', key: 'code'}, 
          {label: 'Name', type: 'string', key: 'name'}, 
          {label: 'Mobile', type: 'string', key: 'mobile'}, 
          {label: 'DOB', type: 'date', key: 'dob'}, 
          {label: 'Status', type: 'status', key: 'status'}, 
          {label: 'Remark', type: 'string', key: 'remark'}, 
          {label: 'Topup/Withdraw/Transfer', type: 'link', key: 'uuid', 'link': '/lo/' + this.company_uuid + '/topup-withdraw/form', hide: true},
        ]}
  }

  async submit() {

    this.tb.reset();

    if (!this.data.code && !this.data.mobile && !this.data.name) {
      return;
    }

    this.data.status = 1;

    this.tb.setSetting = this.setting;
    // this.tb.init(this.setting);
  }

  reset() {
    this.f.resetForm();
    this.tb.reset();
  }
}
